// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__Divider__hxCEy{border-top:1px solid var(--tri-color-fill-secondary);padding-top:var(--tri-space-500);margin-top:var(--tri-space-500)}`, "",{"version":3,"sources":["webpack://./src/components/Divider/styles.module.scss"],"names":[],"mappings":"AAAA,yBACE,oDAAA,CACA,gCAAA,CACA,+BAAA","sourcesContent":[".Divider {\n  border-top: 1px solid var(--tri-color-fill-secondary);\n  padding-top: var(--tri-space-500);\n  margin-top: var(--tri-space-500);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Divider": `sputnik__Divider__hxCEy`
};
export default ___CSS_LOADER_EXPORT___;
